// import React, { PropsWithChildren } from "react";
// import { View, TouchableOpacity } from "react-native";
// import RNModal from "react-native-modal";

// import { sizes } from "assets/constants";
// import { styles } from "./styles";
// import ModalBar from "components/modals/ModalBar";

// type IProps = { visible?: boolean; hide?: () => void; fitHeight?: boolean };

// export default function Modal(props: PropsWithChildren<IProps>) {
//   const { hide, visible } = props;
//   return (
//     <RNModal
//       isVisible={visible}
//       style={styles.modal}
//       onBackButtonPress={hide}
//       animationIn="slideInUp"
//       animationOut="slideOutDown"
//     >
//       <TouchableOpacity
//         activeOpacity={1}
//         onPress={hide}
//         style={{
//           flex: 1,
//           justifyContent: sizes.isMediumScreen ? "center" : "flex-end",
//         }}
//       >
//         <View style={styles.modalContainer}>
//           <TouchableOpacity
//             activeOpacity={1}
//             onPress={null}
//             style={styles.listContainer}
//           >
//             <ModalBar />
//             {props?.children}
//           </TouchableOpacity>
//         </View>
//       </TouchableOpacity>
//     </RNModal>
//   );
// }

import { colors, sizes } from "assets/constants";
import React, { PropsWithChildren } from "react";
import {
  View,
  TouchableWithoutFeedback,
  StatusBar,
  StyleSheet,
} from "react-native";

import RNModal from "react-native-modal";

type Props = { visible?: boolean; hide?: () => void; fitHeight?: boolean };

export default function Modal(props: PropsWithChildren<Props>) {
  const { visible, hide } = props;
  return (
    <RNModal
      accessible
      isVisible={visible}
      onBackButtonPress={hide}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      useNativeDriverForBackdrop
      backdropTransitionInTiming={0}
      backdropTransitionOutTiming={0}
      statusBarTranslucent
      style={styles.modal}
      customBackdrop={
        <View
          style={{
            backgroundColor: colors.black,
            height: sizes.screenH + StatusBar.currentHeight,
          }}
        />
      }
    >
      <TouchableWithoutFeedback onPress={hide} style={{ flex: 1 }}>
        <View style={styles.contentContainer}>{props.children}</View>
      </TouchableWithoutFeedback>
    </RNModal>
  );
}

const styles = StyleSheet.create({
  modal: { margin: 0 },

  contentContainer: { flex: 1, paddingTop: StatusBar.currentHeight },
});
